import React from 'react';

export function SucsessSection() {
  return (
    <section id="s-sucsess" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-sucsess" data-reveal>
          <div className="franchise-sucsess__banner"> Истории успеха партнёров</div>
          <div className="franchise-sucsess__body">
            <img className="franchise-sucsess__body__fish" src="/assets/media/franchise/hero-section/fish-2.svg" alt="Рыбки" />
            <div className="franchise-sucsess__body__bg"> </div>
            <div className="franchise-sucsess__body__content">
              <div className="franchise-sucsess__body__content__box">
                <div className="franchise-sucsess__body__content__box__text">
                  <div className="franchise-sucsess__body__content__box__text__title">
                    <div className="franchise-why-us__body__container__num">1</div>
                    <div className="franchise-sucsess__body__content__box__text__title__name">
                      <img src="/assets/media/franchise/sucsess-section/location.svg" alt="Location" />
                      <span>Ставрополь</span>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__data">
                    <div>
                      <div>Дата открытия:</div>
                      <div>июль 2024</div>
                    </div>
                    <div>
                      <div>Окупаемость:</div>
                      <div>15 месяцев</div>
                    </div>
                    <div>
                      <div>Выход в плюс</div>
                      <div>2 месяца</div>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__description">
                    <div>«Поддержка команды ощущается на каждом этапе работы — от запуска до ежедневных операционных решений»</div>
                    <button type="button" onClick={() => { window.open('https://yandex.ru/maps/org/sushibox/86471026936/reviews/?ll=41.908126%2C45.013876&z=13', '_blank'); }}>Посмотреть точку</button>
                  </div>
                </div>
                <img src="/assets/media/franchise/sucsess-section/stavropol.png" alt="Filial" />
              </div>
              <div className="franchise-sucsess__body__content__box">
                <div className="franchise-sucsess__body__content__box__text">
                  <div className="franchise-sucsess__body__content__box__text__title">
                    <div className="franchise-why-us__body__container__num">2</div>
                    <div className="franchise-sucsess__body__content__box__text__title__name">
                      <img src="/assets/media/franchise/sucsess-section/location.svg" alt="Location" />
                      <span>Краснодар</span>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__data">
                    <div>
                      <div>Дата открытия:</div>
                      <div>апрель 2025</div>
                    </div>
                    <div>
                      <div>Окупаемость:</div>
                      <div>11 месяцев</div>
                    </div>
                    <div>
                      <div>Выход в плюс</div>
                      <div>4 месяца</div>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__description">
                    <div>«Самое ценное — не просто запуск, а постоянное сопровождение. Вместе с управляющей компанией мы регулярно анализируем показатели и улучшаем процессы»</div>
                    <button type="button" onClick={() => { window.open('https://yandex.ru/maps/org/sushibox/225661275899/reviews/?ll=39.035230%2C45.091704&z=16', '_blank'); }}>Посмотреть точку</button>
                  </div>
                </div>
                <img src="/assets/media/franchise/sucsess-section/krasnodar.png" alt="Filial" />
              </div>
              <div className="franchise-sucsess__body__content__box">
                <div className="franchise-sucsess__body__content__box__text">
                  <div className="franchise-sucsess__body__content__box__text__title">
                    <div className="franchise-why-us__body__container__num">3</div>
                    <div className="franchise-sucsess__body__content__box__text__title__name">
                      <img src="/assets/media/franchise/sucsess-section/location.svg" alt="Location" />
                      <span>Мостовской</span>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__data">
                    <div>
                      <div>Дата открытия:</div>
                      <div>апрель 2023</div>
                    </div>
                    <div>
                      <div>Окупаемость:</div>
                      <div>7 месяцев</div>
                    </div>
                    <div>
                      <div>Выход в плюс</div>
                      <div>4 месяца</div>
                    </div>
                  </div>
                  <div className="franchise-sucsess__body__content__box__text__description">
                    <div>«У нас не было опыта в общепите, но благодаря обучению и поддержке запуск прошёл уверенно, а на каждом этапе было к кому обратиться за помощью»</div>
                    <button type="button" onClick={() => { window.open('https://yandex.ru/maps/org/sushibox/236069508242/reviews/?ll=40.789955%2C44.413932&z=16', '_blank'); }}>Посмотреть точку</button>
                  </div>
                </div>
                <img src="/assets/media/franchise/sucsess-section/mostovskoy.png" alt="Filial" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
